export default (str: string): string => str.replace(/\b\w/g, (l) => l.toUpperCase())
